import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { CreateAlertModal } from 'src/modules/features/setting/modals/app-security-modals/create-alert-modal/create-alert-modal.component';
import { DeleteAlertModal } from 'src/modules/features/setting/modals/app-security-modals/delete-alert-modal/delete-alert-modal.component';
import { ViewAlertModal } from 'src/modules/features/setting/modals/app-security-modals/view-alert-modal/view-alert-modal.component';
import { AlertsService } from '../../../services/alerts.service';
import { ConfirmModal } from '@app/shared/modals';
import { SecurityConfirmationModal } from 'src/modules/features/setting/modals/app-security-modals/security-confirmation-modal/security-confirmation-modal.component';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'app-alert-scenario-row',
  templateUrl: './alert-scenarios-row.component.html',
  styleUrls: ['./alert-scenarios-row.component.scss'],
})
export class AlertScenariosRowComponent implements OnChanges {
  constructor(
    private permissionService: PermissionService,
    private modalService: SuiModalService,
    private alertSvc: AlertsService
  ) {}
  @Input() alert: any = {};
  @Input() allAdminUsers: any[] = [];
  @Input() pageChange: boolean;
  @Output() deleteAlertEvent: EventEmitter<any> = new EventEmitter();
  @Output() reloadEvent: EventEmitter<any> = new EventEmitter();
  @Output() success: EventEmitter<string> = new EventEmitter();
  @Output() error: EventEmitter<any> = new EventEmitter();
  @Output() resetPageChange: EventEmitter<any> = new EventEmitter();

  isAlertActive = this.alert?.status === 'ACTIVE' ? true : false;
  notificationSeparated = false;
  processedUsername = false;
  //isIpBlackListed

  viewAlert() {
    this.modalService
      .open(
        new ViewAlertModal('View Alert', {
          ...this.alert,
        })
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  editAlertModal() {
    this.modalService
      .open(
        new CreateAlertModal('Create Alert', {
          operation: 'edit',
          ...this.alert,
        })
      )
      .onApprove(() => {
        this.reloadEvent.emit(true);
      })
      .onDeny(() => {});
  }

  deleteAlert() {
    this.modalService
      .open(
        new SecurityConfirmationModal(
          'Delete Alert',
          'Are you Sure you want to delete this alert?',
          'Yes'
        )
      )
      .onApprove(() => {
        this.deleteAlertEvent.emit(this.alert.alertId);
        setTimeout(() => {
          this.reloadEvent.emit(true);
        });
      })
      .onDeny(() => {});
  }

  deStringifyjson(json: string) {
    return JSON.parse(json);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.alert) {
      this.isAlertActive =
        changes['alert'].currentValue.status === 'ACTIVE' ? true : false;
      this.separateNotifications();
    }

    if (changes?.allAdminUsers && this.alert?.alertScenarioName) {
      this.getUsername();
    }

    if (changes?.pageChange) {
      this.notificationSeparated = false;
      this.processedUsername = false;
      this.resetPageChange.emit();
    }
  }

  separateNotifications() {
    if (this.notificationSeparated) return;
    this.alert = {
      ...this.alert,
      email: this.alert?.notificationSettings?.filter(
        (item) => item.notificationType === 'email'
      ),
      slack: this.alert?.notificationSettings?.filter(
        (item) => item.notificationType === 'slack'
      ),
    };
    this.notificationSeparated = true;
  }

  getUsername() {
    if (this.processedUsername) return;

    let appUserIdOrIp = JSON.parse(this.alert?.configuration).variable;
    const ipRegex =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:))|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,5})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,6})|(([0-9a-fA-F]{1,4}:){1,7}:)|(:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

    if (ipRegex.test(appUserIdOrIp)) {
      this.alert = {
        ...this.alert,
        name: appUserIdOrIp,
      };
    } else {
      for (let i = 0; i < this.allAdminUsers.length; i++) {
        if (this.allAdminUsers[i].user.appUserId === appUserIdOrIp) {
          this.alert = {
            ...this.alert,
            name: `${this.allAdminUsers[i].user.firstName} ${this.allAdminUsers[i].user.lastName}`,
          };
          this.processedUsername = true;
          break;
        }
      }
    }
  }

  pending = false;
  enableOrDisableAlert() {
    this.pending = true;
    this.alertSvc
      .editAlertStatus(this.alert.alertId, {
        ...this.alert,
        status: this.alert.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
      })
      .subscribe(
        (res) => {
          this.success.emit('Updated Successfully');
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error.emit(
            error.error.errorMessage
              ? error.error.errorMessage
              : error.error.error
              ? error.error.error
              : error.error
              ? error.error
              : error.message
              ? error.message
              : error
          );
        }
      );
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;

    return this.permissionService.checkPermission(id, action);
  }
}
